import NegativeFeedbackModal from './NegativeFeedbackModal.component';

export default NegativeFeedbackModal;